import { render, staticRenderFns } from "./salesReturnDetail.vue?vue&type=template&id=2047ccc5"
import script from "./salesReturnDetail.vue?vue&type=script&lang=js"
export * from "./salesReturnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports